import React from 'react';

import styles from '../ChartV2.module.scss';

export interface PaneDividerProps {
  index: number;
  onPointerDown: (
    index: number,
    event: React.PointerEvent<HTMLDivElement>
  ) => void;
}

export const PaneDivider = ({ index, onPointerDown }: PaneDividerProps) => (
  <div
    className={styles.paneDivider}
    role="separator"
    aria-orientation="horizontal"
    data-testid={`chartv2-pane-divider-${index}`}
    onPointerDown={event => onPointerDown(index, event)}
  >
    <span className={styles.paneDividerHandle} aria-hidden />
  </div>
);
